
import { defineComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";
//
import { getCSSVariableValue } from "@/assets/ts/_utils";
import MerchantWidget1 from "@/components/widgets/statsistics/MerchantWidget1.vue";
import ChargebackWidget1 from "@/components/widgets/statsistics/ChargebackWidget1.vue";
//import OrdersWidget1 from "@/components/widgets/statsistics/OrdersWidget1.vue";
import AlertWidget1 from "@/components/widgets/statsistics/AlertWidget1.vue";
import NotificationsWidget1 from "@/components/widgets/statsistics/NotificationsWidget1.vue";
import PerformanceWidget1 from "@/components/widgets/statsistics/PerformanceWidget1.vue";
import PreventionWidget1 from "@/components/widgets/statsistics/PreventionWidget1.vue";
import TransactionWidget1 from "@/components/widgets/statsistics/TransactionWidget1.vue";
import DashboardTotal from "@/components/widgets/mixed/DashboardTotal.vue";
import AlertTotal from "@/components/widgets/mixed/AlertTotal.vue";
//import MixedWidget2 from "@/components/widgets/mixed/Widget2.vue";
//import DashboardRoi from "@/components/widgets/mixed/DashboardRoi.vue";
//import DashboardUnresponded from "@/components/widgets/mixed/DashboardUnresponded.vue";
import ApiService from "@/core/services/ApiService";
import AddAlertSubdomainDrawer from "@/layout/extras/AddAlertSubdomainDrawer.vue";
//
export default defineComponent({
  name: "merchants-insights",
  components: {
    PerformanceWidget1,
    PreventionWidget1,
    //OrdersWidget1,
    NotificationsWidget1,
    TransactionWidget1,
    AlertTotal,
    ChargebackWidget1,
    MerchantWidget1,
    AlertWidget1,
    DashboardTotal,
    // DashboardUnresponded,
    //DashboardRoi,
    //MixedWidget2,
    AddAlertSubdomainDrawer,
  },
  setup() {
    const borderColor = getCSSVariableValue("--bs-border-dashed-color");
    const sparklineData = ref([
      47, 45, 54, 38, 56, 24, 65, 31, 37, 39, 62, 51, 35, 41, 35, 27, 93, 53,
      61, 27, 54, 43, 19, 46,
    ]);

    const chartOptions = ref({
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: true,
          distributed: true,
          barHeight: 23,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      colors: [
        "#3E97FF",
        "#F1416C",
        "#50CD89",
        "#FFC700",
        "#7239EA",
        "#50CDCD",
        "#3F4254",
      ],
      xaxis: {
        categories: [],
        labels: {
          formatter: function (val) {
            return val;
          },
          style: {
            colors: getCSSVariableValue("--bs-gray-400"),
            fontSize: "14px",
            fontWeight: "600",
            align: "left",
          },
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: getCSSVariableValue("--bs-gray-800"),
            fontSize: "14px",
            fontWeight: "600",
          },
          offsetY: 2,
          align: "left",
        },
      },
      grid: {
        borderColor: borderColor,
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
        strokeDashArray: 4,
      },
    });
    const chartOptionsSpark2 = ref({
      chart: {
        type: "area",
        height: 160,
        sparkline: {
          enabled: true,
        },
      },
      stroke: {},
      fill: {
        opacity: 0.8,
      },
      yaxis: {
        min: 0,
        lines: {
          show: true,
        },
      },
      colors: ["#3E97FF"],
      title: {
        text: "$235,312",
        offsetX: 0,
        style: {
          fontSize: "18px",
        },
      },
      subtitle: {
        text: "Expenses",
        offsetX: 0,
        style: {
          fontSize: "14px",
        },
      },
    });
    const series = ref([
      {
        data: [],
        show: false,
      },
    ]);
    const seriesSpark2 = ref([
      {
        data: sparklineData,
        show: false,
      },
    ]);

    const store = useStore();
    const amount = ref("0");
    const count = ref("0");
    const responded = ref("0");
    const matched = ref("0");
    const needed = ref("0");
    const errors = ref("0");
    const unresponded = ref("0");
    const unrespondedPercent = ref("0");
    const creditsRemainingPercent = ref("0");
    const totalSpent = ref("0");
    const creditsRemaining = ref("0");
    const creditsPurchased = ref("0");
    const totalRecovered = ref("0");
    const roi = ref("0");

    onMounted(() => {
      setTimeout(async () => {
        try {
          const { data } = await ApiService.get(
            `reports/chargebacks/dashboard?group_id=${store.getters.currentUser.data.companygroupid}`
          );

          amount.value = data.data[0].amount;
          count.value = data.data[0].count;
          responded.value = (
            (parseFloat(data.data[0].chargebacks_responded) /
              parseFloat(data.data[0].count)) *
            100
          ).toFixed(2);
          matched.value = (
            (parseFloat(data.data[0].chargebacks_matched) /
              parseFloat(data.data[0].count)) *
            100
          ).toFixed(2);
          needed.value = (
            (parseFloat(data.data[0].need_information) /
              parseFloat(data.data[0].count)) *
            100
          ).toFixed(2);
          errors.value = (
            (parseFloat(data.data[0].api_errors) /
              parseFloat(data.data[0].count)) *
            100
          ).toFixed(2);
          unresponded.value = data.data[0].chargebacks_unresponded;
          unrespondedPercent.value = (
            (parseFloat(data.data[0].chargebacks_unresponded) /
              parseFloat(data.data[0].count)) *
            100
          ).toFixed(2);
          totalRecovered.value = data.data[0].recovered;
        } catch (e) {
          amount.value = "0";
          count.value = "0";
          responded.value = "0";
          matched.value = "0";
          needed.value = "0";
          errors.value = "0";
          unresponded.value = "0";
          unrespondedPercent.value = "0";
          totalRecovered.value = "0";
        }

        try {
          const resp = await ApiService.get(
            `reports/customers/orders.spent?group_id=${store.getters.currentUser.data.companygroupid}`
          );
          totalSpent.value = resp.data.data[0].total_spent;
          if (parseFloat(totalRecovered.value) > parseFloat(totalSpent.value)) {
            roi.value = (
              ((parseFloat(totalRecovered.value) -
                parseFloat(totalSpent.value)) /
                parseFloat(totalSpent.value)) *
              100
            ).toFixed(2);
          } else {
            roi.value = "0";
          }
        } catch (e) {
          totalSpent.value = "0";
          roi.value = "0";
        }

        try {
          const resp = await ApiService.get(
            `customers/accounts/${store.getters.currentUser.data.customer_id}`
          );
          creditsRemaining.value = resp.data.data[0].credits_remaining;
          creditsPurchased.value = resp.data.data[0].credits_purchased;
          creditsRemainingPercent.value = (
            (parseFloat(creditsRemaining.value) /
              parseFloat(creditsPurchased.value)) *
            100
          ).toFixed(2);
        } catch (e) {
          creditsRemaining.value = "0";
          creditsPurchased.value = "0";
        }
      }, 1200);
    });

    return {
      series,
      chartOptions,
      chartOptionsSpark2,
      seriesSpark2,
      sparklineData,
      count,
      amount,
      responded,
      matched,
      needed,
      errors,
      unresponded,
      unrespondedPercent,
      totalRecovered,
      totalSpent,
      creditsRemaining,
      creditsPurchased,
      creditsRemainingPercent,
      roi,
    };
  },
});
